import $ from 'jquery';

$(document).ready(function () {
  $(function () {
    $('[data-toggle="tooltip"]').tooltip();
  });
});

$(document).ready(function () {
  // sticky footer hack
  function sticky_footer() {
    var contentHeight =
      $(window).outerHeight() -
      $('footer.main-site-footer').outerHeight() -
      $('header.main-site-header').outerHeight() -
      $('nav').outerHeight();
    $('section.main-content').first().css('min-height', contentHeight);
  }

  // page load
  sticky_footer();
  // re-check heights on resize
  $(window).resize(function () {
    sticky_footer();
  });

  $('#flashMessage').delay(2000).slideUp();
  $('#alert-success').delay(4000).slideUp();
  $('#alert-message:not(.authnet-error)').delay(5000).slideUp();
});
